module.exports = __webpack_public_path__ + "img/21.c373d3c7.jpg";